import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-respond-success',
  templateUrl: './respond-success.component.html',
  styleUrls: ['./respond-success.component.css']
})
export class RespondSuccessComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
